import { Link } from 'react-router-dom';

const footerLinks = [
  { label: '电影', to: '/category/dianying' },
  { label: '电视剧', to: '/category/dianshiju' },
  { label: '综艺', to: '/category/zongyi' },
  { label: '动漫', to: '/category/dongman' },
  { label: '纪录片', to: '/category/jilupian' },
  { label: '关于我们', to: '/about' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-80">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-xl text-white"></i>
              </span>
              <span className="text-xl font-heading font-bold text-white whitespace-nowrap">
                午马影院
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              高清不缓冲免费在线看，流畅播放免费视频高清影视，海量资源即点即播不卡顿。
            </p>
          </div>

          <div className="flex flex-wrap gap-8 lg:gap-16 flex-1">
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#quick-links" className="no-underline text-white">快速导航</a>
              </h4>
              <div className="flex flex-col gap-2">
                {footerLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#contact-info" className="no-underline text-white">联系方式</a>
              </h4>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-foreground-300">邮箱：contact@wumacinema.com</span>
                <span className="text-sm text-foreground-300">客服热线：400-888-9999</span>
                <span className="text-sm text-foreground-300">工作时间：9:00 - 21:00</span>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#legal-info" className="no-underline text-white">法律声明</a>
              </h4>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-foreground-300">用户协议</span>
                <span className="text-sm text-foreground-300">隐私政策</span>
                <span className="text-sm text-foreground-300">版权声明</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2024 午马影院 版权所有 | 本站所有内容均来自互联网，仅供学习交流使用
          </p>
          <p className="text-xs text-foreground-400">
            ICP备案号：京ICP备2024000001号
          </p>
        </div>
      </div>
    </footer>
  );
}